<template>
<div>
    <m-edit-instant-dialog
        title="Select Training Date and Time"
        :value="value"
        ref="dialog"
        :optional="optional"
        v-on:ok="onSet($event)"
        :timezone="timezone"
    />
</div>
</template>

<script>
export default {

    data() {
        return {
            params: null,
            value: null,
            optional: false,
            timezone: null,
            on_set: () => {},
        }
    },

    created () {
        this.$event_bus.$on('pick_time_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('pick_time_dialog',this.showDialog);
    },

    methods: {
        showDialog(params) 
        {
            this.timezone = params.timezone;
            this.optional = params.optional;
            this.on_set = params.on_set;
            this.value = params.value;

            if ( this.timezone == null ) this.timezone = this.$rc.$state.getPrimaryTimezone();
            if ( this.optional == null ) this.optional = false;
            if ( this.on_set == null ) this.on_set = () => {};


            this.$refs['dialog'].showDialog(this.value, this.timezone);
        },

        onSet(time)
        {
            this.on_set(time);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>